import { render } from "./Global_Action_Prompt.vue?vue&type=template&id=4a157080"
import script from "./Global_Action_Prompt.vue?vue&type=script&lang=js"
export * from "./Global_Action_Prompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__